export const elementAtOrDefault = (source, index) => {
    let i = 0;
    for (const item of source) {
        if (index === i++) {
            return item;
        }
    }
    return null;
};
